import React, { createContext } from "react";
import { useEffect } from "react";
import { getData } from "../services/API";
import { useState } from "react";

export const SiteInfo = createContext();

const SiteInfoContext = ({ children }) => {
  const [info, setInfo] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [err, setErr] = useState(false);

  const updateCart = () => {
    getData("/settings/site-info", {}, true)
      .then((res) => {
        setInfo(res.data);
        setLoaded(true);
      })
      .catch((err) => {
        setErr(err.response.data);
        setLoaded(false);
      });
  };

  useEffect(() => {
    updateCart();
  }, []);

  return (
    <SiteInfo.Provider value={{ info, setInfo, loaded, err }}>
      {children}
    </SiteInfo.Provider>
  );
};

export default SiteInfoContext;
